function event(video: HTMLVideoElement, name: 'loadeddata' | 'seeked', signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const clear = () => { clearTimeout(timer); video.removeEventListener(name, done); video.removeEventListener('error', fail); signal.removeEventListener('abort', fail); };
    const done = () => { clear(); resolve(); };
    const fail = () => { clear(); reject(new Error('video_frame_unavailable')); };
    const timer = setTimeout(fail, 12000);
    video.addEventListener(name, done, { once: true }); video.addEventListener('error', fail, { once: true }); signal.addEventListener('abort', fail, { once: true });
    if (signal.aborted) fail();
  });
}
/** Real, independently decoded frames; the preview playhead is never disturbed. */
export async function referenceVideoFrames(src: string, signal: AbortSignal, onFrame: (frame: string, index: number) => void): Promise<void> {
  const video = document.createElement('video');
  video.muted = true; video.playsInline = true; video.crossOrigin = 'anonymous'; video.preload = 'auto';
  try {
    const loaded = event(video, 'loadeddata', signal); video.src = src; video.load(); await loaded;
    const canvas = document.createElement('canvas'); canvas.width = 100; canvas.height = 64;
    const context = canvas.getContext('2d'); if (!context) throw new Error('canvas_unavailable');
    for (let i = 0; i < 14; i++) {
      if (signal.aborted) return;
      const time = (video.duration - .05) * i / 13;
      if (Math.abs(video.currentTime - time) > .001) { const seeked = event(video, 'seeked', signal); video.currentTime = time; await seeked; }
      const scale = Math.max(canvas.width / video.videoWidth, canvas.height / video.videoHeight);
      const width = video.videoWidth * scale, height = video.videoHeight * scale;
      context.drawImage(video, (100 - width) / 2, (64 - height) / 2, width, height);
      onFrame(canvas.toDataURL('image/jpeg', .7), i);
    }
  } finally { video.pause(); video.removeAttribute('src'); video.load(); }
}
